import React, { useEffect, useMemo, useState } from 'react';
import StepperHeading from '../StepperHeading';
import { Grid, Stack, FormControl, Radio, RadioGroup, Typography, TextField, Button, Dialog, DialogContent, Tooltip, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchBar from '../../../../Components/SearchBar';
import { getColorSettings } from '../../../../Utils/helper/commonUtils';
import { AgentCard } from '../../../Agents/Components/AgentCard';
import addie from '../../../../Assets/Image/addie.svg';
import { AppColors } from '../../../../Utils/helper/AppColors';
import CultService from '../../../../Services/CultService';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../../../Utils/helper/HelperTexts';
import PageLoader from '../../../../Components/PageLoader';

// will remove this later in css...

const StyledFormControlLabel = styled('label')(({ theme, checked }) => ({
	border: checked ? 'none' :`1px solid ${AppColors?.lightest_grey}` ,
	display: 'flex',
	flexDirection: 'row',
	borderRadius: '10px',
	padding: '8px 16px',
	margin: '5px',
	minWidth: '350px',
	maxWidth: '450px',
	textAlign: 'center',
	backgroundColor: checked ? AppColors.orange ||theme.quinary : '#ffffff',
    color: checked ?  AppColors.WHITE || theme.fontColor : '#000000',
    
	transition: 'all 0.3s ease',
	cursor: 'pointer',
	position: 'relative',
}));

export default function CampaignConversationType({ details, setDetails, assistants , setAssistants , isCampaignTypeExitInterview}) {
	const [search , setSearch] = useState('');
	const [openDialog, setOpenDialog] = useState(false);
	const [loading, setLoading] = useState(false);
	const company = useSelector((state) => state?.app?.company);


	const getModels = async () => {
			try {
			    setLoading(true);
				let res = await CultService.getAllModelAssistanst({ params: { companyId: company?._id , agentCategory : isCampaignTypeExitInterview ? 'EXIT_INTERVIEW' : ''} });
				if (res.status == 200) {
					let assitetntsData = res?.data?.data || [];
					if(details?.basicDetails?.campaignType === 'EXIT_INTERVIEW'){   // UPDATESEVEN -> No need of this filter as we have predefiend agentCategory future
						let filteredAssistants = assitetntsData.filter(assistant => assistant?.agentDetails?.agentCategory === 'EXIT_INTERVIEW');
						setAssistants(filteredAssistants);
						return;
					}
					else{
                        let filteredAssistants = assitetntsData.filter(assistant => assistant?.agentDetails?.agentCategory !== 'EXIT_INTERVIEW');
						setAssistants(filteredAssistants);
					}
				}
			} catch (err) {
				toast.error(HelperTexts.SOMETHING_WENT_WRONG);
			} finally {
			    setLoading(false);
			}
		};
	
		useEffect(() => {
			if (company?._id) getModels();
		}, [company?._id]);
	const handleInputChange = (key, value) => {
		setDetails({
			...details,
			[key]: value,
		});
	};


	const filteredAssistants = useMemo(
		() => assistants.filter((assistant) =>  assistant?.agentDetails?.agentName?.toLowerCase()?.includes(search?.toLowerCase()) || assistant?.name?.toLowerCase()?.includes(search?.toLowerCase())),
		[assistants, search],
	);

	const localSettingColors = getColorSettings();


	return (
		<>
			<Stack gap={2} p={3}>
				<Typography fontSize={16} fontWeight={600} lineHeight={'150%'} fontFamily={'Poppins'}>
					Select a conversation type
				</Typography>

				<SearchBar width="40%" placeholder="Search Assistant Model" 
				            search={search}     
				            color={ AppColors.midnight_black || localSettingColors.fontColor}
                            bgColor={AppColors.lightest_grey || localSettingColors.quinary} setSearch={setSearch} />

				{/* <StepperHeading title="Conversation Type" subTitle="Select a conversation type for the campaign" /> */}
				{/* <Grid container spacing={2}> */}
				{/* <Grid item xs={12}> */}
				{/* <FormControl component="fieldset" style={{ width: '100%' }}> */}

				<Box sx={{ width: '100%' , height : `calc(100vh - 450px)` , overflowY : 'auto'  }}>
				{ 
				loading ?
				<Stack alignItems="center" justifyContent="center" height="100%">
				<PageLoader fullscreen={false}  />
				</Stack> :
				 
				<RadioGroup
					aria-label="assistant"
					name="assistantId"
					value={details?.assistantId || ''}
					onChange={(e) => handleInputChange('assistantId', e.target.value)}
					style={{
						display: 'flex',
						flexDirection: 'row',
						flexWrap: 'wrap',
					}}
				>
					{filteredAssistants.map((assistant) => (
						<StyledFormControlLabel
							as="div"
							key={assistant.id}
							checked={details?.assistantId === assistant.id}
							theme={localSettingColors}
							onClick={() => handleInputChange('assistantId', assistant.id)}
						>
							<Radio
								value={assistant.id}
								sx={{
									width: '23px',
									height: '37px',
									'&:hover': {
										backgroundColor: 'transparent', // Removes the hover background
									},
									'&.Mui-checked': {
										backdropClasses: 'none',
										backgroundColor: 'transparent',
										color: AppColors.white || localSettingColors.fontColor,
									},

								}}
							/>
							<Stack sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', py: 1, paddingLeft: 2 }}>
								{/* <Typography
									sx={{
										fontSize: '14px',
										fontWeight: 600,
										color: details?.assistantId === assistant.id ? localSettingColors.fontColor : '#000000',
										textAlign: 'start',
									}}
								>
									{assistant.agentDetails.agentName}
								</Typography> */}

								{/* <Tooltip title={assistant?.agentDetails?.agentName || assistant?.name } arrow> */}
									<Typography
										variant="h6"
										color="primary"
										sx={{
											display: '-webkit-box',
											WebkitBoxOrient: 'vertical',
											WebkitLineClamp: 1, // Limit to 3 lines
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											fontSize: '14px',
										    fontWeight: 600,
										    color: details?.assistantId === assistant.id ? AppColors?.white : '#000000',
										    textAlign: 'start',
										}}
									>
										{assistant?.agentDetails?.agentName || assistant?.name  }
									</Typography>
								{/* </Tooltip> */}
								{/* <Typography
									sx={{
										fontSize: '12px',
										fontWeight: 450,
										mt: 0.5,
										mb: 2,
										color: details?.assistantId === assistant.id ? localSettingColors.fontColor : '#000000',
										textAlign: 'start',
									}}
								>
									{assistant.agentDetails.shortDescription}
								</Typography> */}

								{/* <Tooltip title={assistant?.agentDetails?.shortDescription } arrow> */}
									<Typography
										variant="h6"
										color="primary"
										sx={{
											display: '-webkit-box',
											WebkitBoxOrient: 'vertical',
											WebkitLineClamp: 2, // Limit to 3 lines
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											fontSize: '12px',
										fontWeight: 450,
										mt: 0.5,
										mb: 2,
										color: details?.assistantId === assistant.id ? AppColors?.white : '#000000',
										textAlign: 'start',
										wordBreak : 'break-word'
										}}
									>
										{assistant?.agentDetails?.shortDescription }
									</Typography>
								{/* </Tooltip> */}
								<Button
									sx={{
										position: 'absolute',
										bottom: '8px',
										right: '10px',
										p: 0,
										m: 0,
										fontSize: '11px',
										fontWeight: 600,
										height: '20px',
										color: (details?.assistantId === assistant.id) ? AppColors.BLACK : localSettingColors.fontColor,
										'&:hover': { backgroundColor: 'transparent' },
									}}
									onClick={(e) => { e.stopPropagation(); setOpenDialog(assistant)}}
								>
									See More
								</Button>
							</Stack>
						</StyledFormControlLabel>
					))}
				</RadioGroup>}
				</Box>
				{/* </FormControl> */}
				{/* </Grid> */}
				{/* </Grid> */}
			</Stack>
			<Dialog
				open={openDialog}
				onClose={() => setOpenDialog(null)}
				sx={{ '& .MuiDialog-paper': { backgroundColor: 'transparent' } }}
			>
				<DialogContent
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						p: 0, // Add padding if needed
						width: '400px',
						minHeight: '430px',
					}}
				>
					<AgentCard agent={openDialog} agentType={'Campaign Agent'} img={addie} />
				</DialogContent>
			</Dialog>
		</>
	);
}
